import styled from 'styled-components';
import { FullHeightColumn } from '../../../layout/Column';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RightColumn = styled(FullHeightColumn as any)`
 padding: 10px;
	@media (max-width: 990px) {
		padding-top: 20px;
		flex: 0;
	}
}`;
